import React from 'react';
import { Layout, Row, Col, Card, Modal, Button, Popconfirm, Table, Input, notification, Select, DatePicker } from 'antd';
import {
    DeleteOutlined,
    CheckCircleOutlined,
    InfoCircleOutlined,
    CloseCircleOutlined,
    PrinterOutlined,
    DollarCircleOutlined,
    EditOutlined
} from '@ant-design/icons';
import 'antd/dist/antd.css';
import { createupdate, getall, remove, getbyid } from '../../api/api';
import { Typography } from 'antd';
import { Link, browserHistory } from 'react-router';
//import { isLogin } from '../reducer/LocalStoradge';
import ReactToPrint from 'react-to-print';
import styled from 'styled-components';
import moment from 'moment';
import 'moment/locale/id';
moment.locale('id')

export class ComponentToPrint extends React.Component {

    constructor(props) {
        super(props);
        // Don't call this.setState() here!
        this.state = {
            listPegawai: [],
            listSppd: [],
            penandatangan: [],
            kabkota: [],
            provinsi: [],
            instansi: [],
            pengikut: [],
        };
    }

    componentDidMount() {
        this.getSppdByIdForPrint(this.props.dataToPrint)
    }
    // const [listPegawai, setListPegawai] = useState([])
    // const [listSppd, setListSppd] = useState([])
    // const [penandatangan, setPenandatangan] = useState([])
    // const [kabkota, setKabKota] = useState([])
    // const [provinsi, setProvinsi] = useState([])
    // const [instansi, setInstansi] = useState([])
    // const [pengikut, setPengikut] = useState([])

    // useEffect(() => {
    //     console.log(props.dataToPrint)
    // }, [])

    async getSppdByIdForPrint(id) {
        const url = 'getsppdbyidforprint'
        let sppdbyid = await getbyid(id, url)

        this.setState({
            listPegawai: sppdbyid.pegawai[0],
            listSppd: sppdbyid.sppd[0],
            penandatangan: sppdbyid.penandatangan[0],
            kabkota: sppdbyid.kab_kota[0],
            provinsi: sppdbyid.provinsi[0],
            instansi: sppdbyid.instansi[0],
            pengikut: sppdbyid.pengikut,
        })
        console.log(sppdbyid)
        // setListPegawai(sppdbyid.pegawai[0])
        // setListSppd(sppdbyid.sppd[0])
        // setPenandatangan(sppdbyid.penandatangan[0])
        // setKabKota(sppdbyid.kab_kota[0])
        // setProvinsi(sppdbyid.provinsi[0])
        // setInstansi(sppdbyid.instansi[0])
        // setPengikut(sppdbyid.pengikut)
    }

    render() {
        const { listPegawai, listSppd, penandatangan, kabkota, provinsi, instansi, pengikut } = this.state
        return (
            <table style={{ fontSize: 12 }}>
                <table style={{ width: '100%', marginBottom: 10 }}>
                    <tbody>
                        <tr style={{ display: 'flex', alignContent: 'center', justifyContent: 'center' }}>
                            <td></td>
                            <td style={{ fontSize: 24, color: 'black ' }}>{instansi.nama_instansi}</td>
                        </tr>
                        <tr style={{ display: 'flex', alignContent: 'center', justifyContent: 'center' }}>
                            <td></td>
                            <td style={{ fontSize: 20, color: 'black ' }}>{instansi.kota}</td>
                        </tr>
                        <tr style={{ display: 'flex', alignContent: 'center', justifyContent: 'center', marginBottom: 10 }}>
                            <td></td>
                            <td>{instansi.alamat}</td>
                        </tr>
                    </tbody>
                </table>
                <hr style={{ borderWidth: 2, borderColor: 'black', marginBottom: 10 }} />
                <table style={{ width: '100%', marginBottom: 20 }}>
                    <tbody>
                        <tr style={{ display: 'flex', alignContent: 'center', justifyContent: 'center' }}>
                            <td></td>
                            <td style={{ fontSize: 14, color: 'black ' }}>SURAT PERINTAH PERJALANAN DINAS</td>
                        </tr>
                        <tr style={{ display: 'flex', alignContent: 'center', justifyContent: 'center', marginBottom: 10 }}>
                            <td></td>
                            <td>Nomor : {listSppd.nomor_surat}</td>
                        </tr>
                    </tbody>
                </table>

                <table style={{ width: '100%', }}>
                    <tbody style={{ width: '100%' }}>
                        <tr style={{ width: '100%', border: '4px solid black', borderWidth: 1, borderColor: 'black', marginTop: 1 }}>
                            <td style={{ width: '3%', border: '1px solid black', borderWidth: 1, borderColor: 'black', textAlign: 'center' }}>1</td>
                            <td style={{ width: '40%', padding: 8, border: '1px solid black', borderWidth: 1, borderColor: 'black' }}>Pejabat yang memberikan perintah</td>
                            <td style={{ width: '57%', padding: 8, border: '1px solid black', borderWidth: 1, borderColor: 'black' }}>{penandatangan.jabatan}</td>
                        </tr>
                        <tr style={{ border: '4px solid black', borderWidth: 1, borderColor: 'black', marginTop: 1 }} >
                            <td style={{ width: '3%', border: '1px solid black', borderWidth: 1, borderColor: 'black', textAlign: 'center' }}>2</td>
                            <td style={{ width: '40%', padding: 8, border: '1px solid black', borderWidth: 1, borderColor: 'black' }}>Nama Pegawai yang diperintah mengadakan perjalanan</td>
                            <td style={{ width: '57%', padding: 8, border: '1px solid black', borderWidth: 1, borderColor: 'black' }}>{listPegawai.nama_pegawai}</td>
                        </tr>
                        <tr style={{ border: '4px solid black', borderWidth: 1, borderColor: 'black', marginTop: 1 }} >
                            <td style={{ width: '3%', border: '1px solid black', borderWidth: 1, borderColor: 'black', textAlign: 'center' }}>3</td>
                            <td style={{ width: '40%', padding: 8, border: '1px solid black', borderWidth: 1, borderColor: 'black' }}>
                                a. Pangkat dan Golongan<br />
                                    b. Jabatan<br />
                                    c. Tingkat menurut peraturan perjalanan
                                </td>
                            <td style={{ width: '57%', padding: 8, border: '1px solid black', borderWidth: 1, borderColor: 'black' }}>
                                {listPegawai.pangkat_gol}<br />
                                {listPegawai.jabatan}<br />
                                {listSppd.peraturan_perjalanan}
                            </td>
                        </tr>
                        <tr style={{ border: '4px solid black', borderWidth: 1, borderColor: 'black', marginTop: 1 }} >
                            <td style={{ width: '3%', border: '1px solid black', borderWidth: 1, borderColor: 'black', textAlign: 'center' }}>4</td>
                            <td style={{ width: '40%', padding: 8, border: '1px solid black', borderWidth: 1, borderColor: 'black' }}>Maksud Perjalanan Dinas</td>
                            <td style={{ width: '57%', padding: 8, border: '1px solid black', borderWidth: 1, borderColor: 'black' }}>{listSppd.maksud}</td>
                        </tr>
                        <tr style={{ border: '4px solid black', borderWidth: 1, borderColor: 'black', marginTop: 1 }} >
                            <td style={{ width: '3%', border: '1px solid black', borderWidth: 1, borderColor: 'black', textAlign: 'center' }}>5</td>
                            <td style={{ width: '40%', padding: 8, border: '1px solid black', borderWidth: 1, borderColor: 'black' }}>Dasar Perjalanan Dinas</td>
                            <td style={{ width: '57%', padding: 8, border: '1px solid black', borderWidth: 1, borderColor: 'black' }}>{listSppd.dasar}</td>
                        </tr>
                        <tr style={{ border: '4px solid black', borderWidth: 1, borderColor: 'black', marginTop: 1 }} >
                            <td style={{ width: '3%', border: '1px solid black', borderWidth: 1, borderColor: 'black', textAlign: 'center' }}>6</td>
                            <td style={{ width: '40%', padding: 8, border: '1px solid black', borderWidth: 1, borderColor: 'black' }}>
                                a. Tempat berangkat<br />
                                    b. Tempat tujuan
                                </td>
                            <td style={{ width: '57%', padding: 8, border: '1px solid black', borderWidth: 1, borderColor: 'black' }}>
                                {instansi.kota}<br />
                                {kabkota.nama}, {provinsi.nama}
                            </td>
                        </tr>
                        <tr style={{ border: '4px solid black', borderWidth: 1, borderColor: 'black', marginTop: 1 }} >
                            <td style={{ width: '3%', border: '1px solid black', borderWidth: 1, borderColor: 'black', textAlign: 'center' }}>7</td>
                            <td style={{ width: '40%', padding: 8, border: '1px solid black', borderWidth: 1, borderColor: 'black' }}>
                                a. Lamanya Perjalanan<br />
                                    b. Tanggal Berangkat<br />
                                    c. Tanggal harus kembali
                                </td>
                            <td style={{ width: '57%', padding: 8, border: '1px solid black', borderWidth: 1, borderColor: 'black' }}>
                                {moment(listSppd.tanggal_pulang).diff(moment(listSppd.berangkat), 'days')} hari <br />
                                {moment(listSppd.tanggal_berangkat).format('LL')} <br />
                                {moment(listSppd.tanggal_pulang).format('LL')}
                            </td>
                        </tr>
                        <tr style={{ border: '4px solid black', borderWidth: 1, borderColor: 'black', marginTop: 1 }} >
                            <td style={{ width: '3%', border: '1px solid black', borderWidth: 1, borderColor: 'black', textAlign: 'center' }}>8</td>
                            <td style={{ width: '40%', padding: 8, border: '1px solid black', borderWidth: 1, borderColor: 'black' }}>Pengikut</td>
                            <td style={{ width: '57%', padding: 8, border: '1px solid black', borderWidth: 1, borderColor: 'black' }}>
                                {pengikut.map((nama, index) =>
                                    <>{index + 1}. {nama.pengikut} <br /></>
                                )}
                            </td>
                        </tr>
                        <tr style={{ border: '4px solid black', borderWidth: 1, borderColor: 'black', marginTop: 1 }} >
                            <td style={{ width: '3%', border: '1px solid black', borderWidth: 1, borderColor: 'black', textAlign: 'center' }}>9</td>
                            <td style={{ width: '40%', padding: 8, border: '1px solid black', borderWidth: 1, borderColor: 'black' }}>Keterangan lainnya</td>
                            <td style={{ width: '57%', padding: 8, border: '1px solid black', borderWidth: 1, borderColor: 'black' }}>{listSppd.keterangan}</td>
                        </tr>

                    </tbody>
                </table>
                <table>
                    <tr >
                        <td style={{ width: '50%', padding: 20 }}></td>
                        <td style={{ width: '50%', padding: 20 }}>
                            Dikeluarkan di {instansi.kota}<br />
                                    Pada tanggal {moment(listSppd.tanggaldikeluarkan).format('LL')}<br />
                            {penandatangan.jabatan}<br />
                            <br />
                            <br />
                            <br />
                            <br />
                            {penandatangan.nama_pegawai}<br />
                                    NIP. {penandatangan.nip} <br />
                        </td>
                    </tr>
                </table>
            </table>
        );
    }

}